module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_data04-sp-94bdddbeab07e57a84e5f6457c4fa95c.png";